import { toJS } from "mobx";

export const getTaskRows = (task_list) => {
    return toJS(task_list).map((item) => {
        return {
            task_name: item?.node?.display,
            assigned_to: item?.user,
            region:
                item?.node?.piv_level1 && item?.node?.piv_level1 !== ""
                    ? item?.node?.piv_level1
                    : "/",
            interviews_count: Number(item?.count?.count),
            field_work_progress: item?.status,
            ...item,
        };
    });
};
